import { WSFilterValues } from "../types";

export const hasValues = (values: WSFilterValues) => {
  return Object.values(values).some((value) =>
    Array.isArray(value) ? value.length > 0 : value !== undefined
  );
};
